import { render, staticRenderFns } from "./SignupPending.vue?vue&type=template&id=a20c9318"
import script from "./SignupPending.vue?vue&type=script&lang=js"
export * from "./SignupPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports